export enum IpWhiteListState {
  None,
  Change,
  Add,
  Delete
}

export default class IpWhiteList {
  id?: number;
  description: string;
  ips: string[];
  ipRanges: string[];
  state: IpWhiteListState;
  hidden?: boolean;

  constructor() {
    this.description = '';
    this.state = IpWhiteListState.None;
  }
}

export class IpWhiteListTableModel extends IpWhiteList {
  index: number;

  constructor() {
    super();
    this.index = 0;
  }
}

export type IpWhiteListFullModel = {
  restrictionByIpsOn: boolean;
  whiteLists: IpWhiteList[];
};
